import styled from '@emotion/styled';
import { Breadcrumbs } from '@mui/material';
import { colors } from 'theme/colors';

const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-bottom: 15px;

  & li,
  & li span {
    color: ${colors.blue400};
    letter-spacing: 0.08em;
    font-weight: 600;
  }

  & li:last-of-type,
  & li:nth-last-of-type(2),
  & li:nth-last-of-type(2) span,
  & li:last-child span {
    color: ${colors.blue400};
    font-weight: 600;
  }

  & li:first-of-type span {
    padding: 0 10px 10px 0;
  }

  & li a,
  & li span {
    color: ${colors.blue600};
    font-family: NotoSansLight, sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-transform: none;
    text-decoration: none;
  }

  & li.MuiBreadcrumbs-separator {
    position: relative;

    & > svg {
      top: -3px;
      left: 3px;
      position: absolute;
    }
  }
`;

export { StyledBreadcrumbs };
